import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SynchronizedObjectClass;
function SynchronizedObject() {
  if (SynchronizedObjectClass === VOID) {
    class $ {}
    initMetadataForClass($, 'SynchronizedObject', SynchronizedObject);
    SynchronizedObjectClass = $;
  }
  return SynchronizedObjectClass;
}
//region block: exports
export {
  SynchronizedObject as SynchronizedObject32xqzf15iiskd,
};
//endregion

//# sourceMappingURL=Synchronized.mjs.map
